(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2048],{

/***/ 1157:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tug/apply",
      function () {
        return __webpack_require__(36236);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Link = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.attrs */ .ZP.a.attrs({
    target: "_blank",
    rel: "noreferrer"
})(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
Link.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 36236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/tug/apply/apply.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 4rem auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* responsive */.jW());
var Content = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        64,
        32
    ]
})(_templateObject1());
var Panel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    md: 12,
    sm: 24
})(_templateObject2());

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyStart/applyStart.styled.js
function applyStart_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function applyStart_styled_templateObject() {
    var data = applyStart_styled_taggedTemplateLiteral([
        ""
    ]);
    applyStart_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function applyStart_styled_templateObject1() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  text-align: center;\n  color: ",
        ";\n  font-size: 30px;\n"
    ]);
    applyStart_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function applyStart_styled_templateObject2() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 80px;\n\n  img {\n    width: 100%;\n  }\n"
    ]);
    applyStart_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  margin-top: 60px;\n  margin-bottom: 40px;\n  color: ",
        ";\n  font-size: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 60px;\n  color: ",
        ";\n  font-size: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  margin-top: 60px;\n  margin-bottom: 40px;\n  color: ",
        ";\n  font-size: 24px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  padding: 40px 20px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  margin-right: 10px;\n\n  &,\n  img {\n    ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = applyStart_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 16px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(applyStart_styled_templateObject());
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(applyStart_styled_templateObject1(), colors.F1);
var Post = styled_components_browser_esm/* default.div */.ZP.div(applyStart_styled_templateObject2());
var Question = styled_components_browser_esm/* default.h2 */.ZP.h2(_templateObject3(), colors.F1);
var Answer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), colors.F2);
var WhyJoinTitle = styled_components_browser_esm/* default.h2 */.ZP.h2(_templateObject5(), colors.F1);
var WhyJoinList = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6(), colors.T2);
var WhyJoinListItem = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7());
var WhyJoinListItemIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), mixins/* size */.dp("40px"));
var WhyJoinListItemText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9(), colors.F2);

// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyStart/applyStart.constants.js

var getImage = function(filename) {
    return utils/* cdn.getImageUrl */.cK.getImageUrl("/images/people/apply/".concat(filename));
};
var title = "TiDB User Group \u4F1A\u5458\u7533\u8BF7";
var postImageUrl = getImage("post.png");
var question = "TUG \u662F\u4EC0\u4E48";
var answer = "TUG \u662F\u6C47\u805A\u5168\u7403\u6570\u636E\u5E93\u3001\u5927\u6570\u636E\u6280\u672F\u4ECE\u4E1A\u8005\u7684\u793E\u533A\uFF0C\u662F\u4E00\u4E2A\u72EC\u7ACB\u3001\u81EA\u53D1\u3001\u4E0D\u4EE5\u76C8\u5229\u4E3A\u76EE\u7684\u7684\u7EC4\u7EC7\u3002";
var whyJoinTitle = "\u52A0\u2F0ATUG \uFF0C\u4F60\u80FD\u83B7\u5F97\u4EC0\u4E48\uFF1F";
var whyJoinItems = [
    {
        iconUrl: getImage("why-join-1.svg"),
        text: "\u8BA9\u6570\u636E\u5E93\u3001\u5927\u6570\u636E\u4ECE\u4E1A\u8005\u627E\u5230\u81EA\u5DF1\u7684\u5708\u5B50"
    },
    {
        iconUrl: getImage("why-join-2.svg"),
        text: "\u63A2\u7D22\u6280\u672F\u95EE\u9898\uFF0C\u968F\u65F6\u968F\u5730\u4EA4\u6D41\u6210\u957F\uFF0C\u89E3\u51B3\u95EE\u9898"
    },
    {
        iconUrl: getImage("why-join-3.svg"),
        text: "\u53D1\u8868\u6280\u672F\u89C1\u89E3\uFF0C\u6536\u83B7\u524D\u6CBF\u77E5\u8BC6\uFF0C\u63D0\u5347\u4E2A\u4EBA\u5F71\u54CD\u529B"
    }, 
];

;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyStart/ApplyStart.component.js





var ApplyStart = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Post, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: postImageUrl,
                    alt: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                children: question
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Answer, {
                children: answer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyJoinTitle, {
                children: whyJoinTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyJoinList, {
                children: whyJoinItems.map(function(param) {
                    var text = param.text, iconUrl = param.iconUrl;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhyJoinListItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyJoinListItemIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: text,
                                    src: iconUrl
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyJoinListItemText, {
                                children: text
                            })
                        ]
                    }, text);
                })
            })
        ]
    });
};
/* harmony default export */ var ApplyStart_component = (ApplyStart);

;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyStart/index.js


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 14 modules
var modal = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./packages/datasource/src/api/tug/apply.js
var apply = __webpack_require__(74855);
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/applyEnd.styled.js
function applyEnd_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function applyEnd_styled_templateObject() {
    var data = applyEnd_styled_taggedTemplateLiteral([
        ""
    ]);
    applyEnd_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var applyEnd_styled_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(applyEnd_styled_templateObject());

// EXTERNAL MODULE: ./node_modules/formik-antd/es/select/index.js
var es_select = __webpack_require__(76453);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/form/form.js
var form_form = __webpack_require__(14271);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/input/index.js
var input = __webpack_require__(96127);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/auto-complete/index.js + 1 modules
var auto_complete = __webpack_require__(8479);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/checkbox/index.js
var es_checkbox = __webpack_require__(42842);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./packages/ui/src/components/link/Link.component.js
var Link_component = __webpack_require__(33358);
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/form.styled.js
function form_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function form_styled_templateObject() {
    var data = form_styled_taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  margin: auto;\n  padding: 40px;\n  background-color: rgb(247, 248, 249);\n"
    ]);
    form_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function form_styled_templateObject1() {
    var data = form_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n  line-height: 24px;\n"
    ]);
    form_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function form_styled_templateObject2() {
    var data = form_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  line-height: 24px;\n  margin-bottom: 28px;\n"
    ]);
    form_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function form_styled_templateObject3() {
    var data = form_styled_taggedTemplateLiteral([
        ""
    ]);
    form_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function form_styled_templateObject4() {
    var data = form_styled_taggedTemplateLiteral([
        ""
    ]);
    form_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function form_styled_templateObject5() {
    var data = form_styled_taggedTemplateLiteral([
        ""
    ]);
    form_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var FormContainer = styled_components_browser_esm/* default.div */.ZP.div(form_styled_templateObject());
var FormTitleContainer = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    justify: "space-between",
    align: "bottom"
})(form_styled_templateObject1());
var FormTitle = styled_components_browser_esm/* default.h2 */.ZP.h2(form_styled_templateObject2(), mixins/* typography */.cp(2));
var Form = styled_components_browser_esm/* default.div */.ZP.div(form_styled_templateObject3());
var FormSubmitButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z)(form_styled_templateObject4());
var FormSubmitAgreement = (0,styled_components_browser_esm/* default */.ZP)(Link_component/* default */.Z)(form_styled_templateObject5());

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./packages/datasource/src/index.js + 24 modules
var src = __webpack_require__(72579);
// EXTERNAL MODULE: ./packages/common/src/index.js + 3 modules
var common_src = __webpack_require__(94174);
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/fields/optionStageOfCompanyUseOfTidb.json
var optionStageOfCompanyUseOfTidb_namespaceObject = JSON.parse('["生产阶段","测试阶段","调研阶段","不考虑使用","其他（请自行输入）"]');
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/fields/optionPreferredWayOfSharing.json
var optionPreferredWayOfSharing_namespaceObject = JSON.parse('["参与讨论技术问题","回复他⼈技术困惑","分享技术⼼得","撰写技术⽂章","线下演讲布道"]');
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/fields/optionRolesWantToPlay.json
var optionRolesWantToPlay_namespaceObject = JSON.parse('["加⼊ TUG 管理委员会，参与 TUG ⽇常事务管理","加⼊ TUG 区域组，负责组织区域 TUG 的线下活动技术困惑","加⼊ TUG 内容组，负责 TUG 内容建设⼼得","先围观看看⽂章"]');
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/fields/optionChannel.json
var optionChannel_namespaceObject = JSON.parse('["平凯星辰 Education","TUG 企业行","TUG 成员推荐","AskTUG 论坛","TiDB 社区","其他（请自行输入）"]');
;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/fields/enums.js




var convertArrayToSelectOptionItem = function(arr) {
    return arr.map(function(value) {
        return {
            value: value,
            label: value
        };
    });
};
var stageOfCompanyUseOfTidb = convertArrayToSelectOptionItem(optionStageOfCompanyUseOfTidb_namespaceObject);
var preferredWayOfSharing = convertArrayToSelectOptionItem(optionPreferredWayOfSharing_namespaceObject);
var rolesWantToPlay = convertArrayToSelectOptionItem(optionRolesWantToPlay_namespaceObject);
var channel = convertArrayToSelectOptionItem(optionChannel_namespaceObject);

;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/fields/index.js



;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/form.data.js






var form_data_stageOfCompanyUseOfTidb = stageOfCompanyUseOfTidb, form_data_preferredWayOfSharing = preferredWayOfSharing, form_data_rolesWantToPlay = rolesWantToPlay, form_data_channel = channel;
var buildSchema = common_src/* utils.form.buildSchema */.P6.cr.buildSchema;
var formData = (0,src/* getFormData */.zi)();
var personalPositions = formData.org.enums.personalPositions;
var data = {
    form: {
        realName: {
            name: "real_name",
            placeholder: "\u771F\u5B9E\u59D3\u540D",
            validator: yup_es/* string */.Z_().min(2, function(param) {
                var min = param.min;
                return "\u771F\u5B9E\u59D3\u540D\u6700\u77ED\u4E3A ".concat(min, " \u4E2A\u5B57\u7B26");
            }).max(20, function(param) {
                var max = param.max;
                return "\u771F\u5B9E\u59D3\u540D\u6700\u957F\u4E3A ".concat(max, " \u4E2A\u5B57\u7B26");
            }).required("\u771F\u5B9E\u59D3\u540D\u4E0D\u53EF\u4E3A\u7A7A")
        },
        phone: {
            name: "phone",
            placeholder: "\u624B\u673A\u53F7\u7801",
            validator: yup_es/* string */.Z_().required("\u624B\u673A\u53F7\u7801\u4E0D\u53EF\u4E3A\u7A7A")
        },
        email: {
            name: "email",
            placeholder: "\u90AE\u7BB1",
            validator: yup_es/* string */.Z_().email("\u8BF7\u8F93\u5165\u6709\u6548\u7684\u90AE\u7BB1").required("\u90AE\u7BB1\u4E0D\u53EF\u4E3A\u7A7A")
        },
        companyName: {
            name: "company_name",
            placeholder: "\u516C\u53F8",
            labelInValue: false,
            validator: yup_es/* mixed */.nK().required("\u516C\u53F8\u4E0D\u53EF\u4E3A\u7A7A")
        },
        jobTitle: {
            name: "job_title",
            placeholder: "\u804C\u4F4D",
            options: personalPositions,
            validator: yup_es/* mixed */.nK().required("\u672C\u9879\u76EE\u4E0D\u53EF\u4E3A\u7A7A")
        },
        stageOfCompanyUseOfTidb: {
            name: "stage_of_company_use_of_tidb",
            placeholder: "\u4F60\u7684\u516C\u53F8\u5BF9 TiDB \u6B63\u5904\u4E8E",
            options: form_data_stageOfCompanyUseOfTidb,
            validator: yup_es/* mixed */.nK().required("\u672C\u9879\u76EE\u4E0D\u53EF\u4E3A\u7A7A")
        },
        reasonForApplication: {
            name: "reason_for_application",
            placeholder: "\u4F60\u52A0\u2F0A TUG \u7684\u539F\u56E0",
            validator: yup_es/* string */.Z_().min(5, function(param) {
                var min = param.min;
                return "\u539F\u56E0\u6700\u77ED\u4E3A ".concat(min, " \u4E2A\u5B57\u7B26");
            }).max(500, function(param) {
                var max = param.max;
                return "\u539F\u56E0\u6700\u957F\u4E3A ".concat(max, " \u4E2A\u5B57\u7B26");
            }).required("\u539F\u56E0\u4E0D\u53EF\u4E3A\u7A7A")
        },
        preferredWayOfSharing: {
            name: "preferred_way_of_sharing",
            placeholder: "\u8BF7\u9009\u62E9\u4F60\u4E50\u4E8E\u5206\u4EAB\u7684\u2F45\u5F0F",
            items: form_data_preferredWayOfSharing,
            validator: yup_es/* mixed */.nK().required("\u672C\u9879\u76EE\u4E0D\u53EF\u4E3A\u7A7A")
        },
        rolesWantToPlay: {
            name: "roles_want_to_play",
            placeholder: "\u4F60\u5E0C\u671B\u62C5\u4EFB TUG \u4EC0\u4E48\u2EC6\u2F8A",
            items: form_data_rolesWantToPlay,
            validator: yup_es/* mixed */.nK().required("\u672C\u9879\u76EE\u4E0D\u53EF\u4E3A\u7A7A")
        },
        wechatId: {
            name: "wechat_id",
            placeholder: "\u5FAE\u4FE1 ID\uFF08\u786E\u4FDD\u53EF\u4EE5\u641C\u7D22\u5230\uFF0C\u4EE5\u4FBF\u4E8E\u2F29\u52A9\u2F3F\u53EF\u4EE5\u9080\u8BF7\u8FDB\u7FA4\uFF09",
            validator: yup_es/* string */.Z_().min(2, function(param) {
                var min = param.min;
                return "\u5FAE\u4FE1 ID \u6700\u77ED\u4E3A ".concat(min, " \u4E2A\u5B57\u7B26");
            }).max(25, function(param) {
                var max = param.max;
                return "\u5FAE\u4FE1 ID \u6700\u957F\u4E3A ".concat(max, " \u4E2A\u5B57\u7B26");
            }).required("\u5FAE\u4FE1 ID \u4E0D\u53EF\u4E3A\u7A7A")
        },
        bio: {
            name: "bio",
            placeholder: "\u4E09\u56DB\u53E5\u8BDD\u4ECB\u7ECD\u2F00\u4E0B\u2F83\u2F30\uFF08\u2F64\u4E8E\u2F0A\u7FA4\u4ECB\u7ECD\uFF09",
            validator: yup_es/* string */.Z_().min(5, function(param) {
                var min = param.min;
                return "\u81EA\u6211\u4ECB\u7ECD\u6700\u77ED\u4E3A ".concat(min, " \u4E2A\u5B57\u7B26");
            }).max(200, function(param) {
                var max = param.max;
                return "\u81EA\u6211\u4ECB\u7ECD\u6700\u957F\u4E3A ".concat(max, " \u4E2A\u5B57\u7B26");
            })
        },
        channel: {
            name: "channel",
            placeholder: "\u5728\u54EA\u5F97\u77E5 TUG",
            options: form_data_channel
        },
        referrer: {
            name: "referrer",
            placeholder: "\u63A8\u8350\u2F08",
            validator: yup_es/* string */.Z_().min(2, function(param) {
                var min = param.min;
                return "\u63A8\u8350\u2F08\u6700\u77ED\u4E3A ".concat(min, " \u4E2A\u5B57\u7B26");
            }).max(10, function(param) {
                var max = param.max;
                return "\u63A8\u8350\u2F08\u6700\u957F\u4E3A ".concat(max, " \u4E2A\u5B57\u7B26");
            })
        },
        agreement: {
            name: "agreement",
            validator: yup_es/* bool */.Xg().oneOf([
                true
            ], "\u9700\u9605\u8BFB\u5E76\u540C\u610F\u76F8\u5173\u534F\u8BAE").required("\u9700\u9605\u8BFB\u5E76\u540C\u610F\u76F8\u5173\u534F\u8BAE"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\u672C\u4EBA\u5DF2\u9605\u8BFB\u5E76\u540C\u610F TiDB Community \u7684",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubmitAgreement, {
                        href: "https://www.pingcap.cn/privacy-policy",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "\u300A\u9690\u79C1\u653F\u7B56\u300B"
                    })
                ]
            })
        }
    },
    submitBtnTitle: "\u63D0\u4EA4\u7533\u8BF7"
};
data.formSchema = buildSchema(data.form);
/* harmony default export */ var form_data = (data);

// EXTERNAL MODULE: ./src/utils/form.utils.js
var form_utils = __webpack_require__(9716);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 44 modules
var antd_es_select = __webpack_require__(18963);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
;// CONCATENATED MODULE: ./packages/ui/src/components/remoteSelect/RemoteSelect.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var RemoteSelect = function(_param) {
    var fetchOptions = _param.fetchOptions, _debounceTimeout = _param.debounceTimeout, debounceTimeout = _debounceTimeout === void 0 ? 800 : _debounceTimeout, _Select = _param.Select, Select = _Select === void 0 ? antd_es_select/* default */.Z : _Select, props = _objectWithoutProperties(_param, [
        "fetchOptions",
        "debounceTimeout",
        "Select"
    ]);
    var ref = (0,react.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react.useState)([]), options1 = ref1[0], setOptions = ref1[1];
    var fetchRef = (0,react.useRef)(0);
    var debounceFetcher = (0,react.useMemo)(function() {
        var loadOptions = function(value) {
            fetchRef.current += 1;
            var fetchId = fetchRef.current;
            setOptions([]);
            setIsFetching(true);
            fetchOptions(value).then(function(options) {
                // fetch is asynchronous, so the condition will make sure the
                // callback only updates for its own fetcher
                if (fetchId !== fetchRef.current) {
                    return;
                }
                setOptions(options);
                setIsFetching(false);
            });
        };
        return debounce_default()(loadOptions, debounceTimeout);
    }, [
        fetchOptions,
        debounceTimeout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, _objectSpread({
        filterOption: false,
        labelInValue: true,
        notFoundContent: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
            size: "small"
        }) : null,
        onSearch: debounceFetcher,
        options: options1,
        showSearch: true
    }, props));
};
RemoteSelect.propTypes = _objectSpread({}, antd_es_select/* default.propTypes */.Z.propTypes, {
    debounceTimeout: (prop_types_default()).number,
    fetchOptions: (prop_types_default()).func.isRequired
});
/* harmony default export */ var RemoteSelect_component = (RemoteSelect);

;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/Form.component.js
function Form_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Form_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Form_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var Form_component_form = form_data.form, submitBtnTitle = form_data.submitBtnTitle, formSchema = form_data.formSchema;
var realName = Form_component_form.realName, phone = Form_component_form.phone, email = Form_component_form.email, companyName = Form_component_form.companyName, jobTitle = Form_component_form.jobTitle, Form_component_stageOfCompanyUseOfTidb = Form_component_form.stageOfCompanyUseOfTidb, reasonForApplication = Form_component_form.reasonForApplication, Form_component_preferredWayOfSharing = Form_component_form.preferredWayOfSharing, Form_component_rolesWantToPlay = Form_component_form.rolesWantToPlay, wechatId = Form_component_form.wechatId, bio = Form_component_form.bio, Form_component_channel = Form_component_form.channel, referrer = Form_component_form.referrer, agreement = Form_component_form.agreement;
var Form_component_Form = function(param1) {
    var onSubmit = param1.onSubmit, isSubmitting = param1.isSubmitting;
    var ref = (0,dist/* default */.ZP)("account.settings"), settingsResp = ref.data, settingsError = ref.error;
    var ref1 = (0,dist/* default */.ZP)("profile.fetch"), profileResp = ref1.data, profileError = ref1.error;
    var isLoading = !profileResp || !settingsResp || settingsError || profileError;
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        active: true
    });
    var _phone, _email, _company_name, _job_title;
    var _obj;
    var initialValues = (_obj = {}, Form_component_defineProperty(_obj, realName.name, ""), Form_component_defineProperty(_obj, phone.name, (_phone = settingsResp.data.phone) !== null && _phone !== void 0 ? _phone : ""), Form_component_defineProperty(_obj, email.name, (_email = settingsResp.data.email) !== null && _email !== void 0 ? _email : ""), Form_component_defineProperty(_obj, companyName.name, (_company_name = profileResp.data.company_name) !== null && _company_name !== void 0 ? _company_name : ""), Form_component_defineProperty(_obj, jobTitle.name, (_job_title = profileResp.data.job_title) !== null && _job_title !== void 0 ? _job_title : ""), Form_component_defineProperty(_obj, Form_component_stageOfCompanyUseOfTidb.name, ""), Form_component_defineProperty(_obj, reasonForApplication.name, ""), Form_component_defineProperty(_obj, Form_component_preferredWayOfSharing.name, ""), Form_component_defineProperty(_obj, Form_component_rolesWantToPlay.name, ""), Form_component_defineProperty(_obj, wechatId.name, ""), Form_component_defineProperty(_obj, agreement.name, ""), _obj);
    var fetchOpt = {
        fetchOptions: form_utils.fetchOrganizationOptions,
        Select: es_select/* Select */.P
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTitle, {
                children: "\u7533\u8BF7\u4FE1\u606F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    initialValues: initialValues,
                    validationSchema: formSchema,
                    onSubmit: onSubmit,
                    children: function(param) {
                        var errors = param.errors;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_form/* Form */.l, {
                            layout: "vertical",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: realName.name,
                                    label: realName.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, Form_component_objectSpread({}, realName))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: phone.name,
                                    label: phone.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, Form_component_objectSpread({}, phone, {
                                        disabled: !!settingsResp.data.phone
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: email.name,
                                    label: email.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, Form_component_objectSpread({}, email, {
                                        disabled: !!settingsResp.data.email_verified
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: companyName.name,
                                    label: companyName.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteSelect_component, Form_component_objectSpread({}, companyName, fetchOpt, {
                                        disabled: !profileResp.data.company_name_editable
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: jobTitle.name,
                                    label: jobTitle.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* Select */.P, Form_component_objectSpread({}, jobTitle))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: Form_component_stageOfCompanyUseOfTidb.name,
                                    label: Form_component_stageOfCompanyUseOfTidb.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auto_complete/* AutoComplete */.Q, Form_component_objectSpread({}, Form_component_stageOfCompanyUseOfTidb))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: reasonForApplication.name,
                                    label: reasonForApplication.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, Form_component_objectSpread({}, reasonForApplication))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: Form_component_preferredWayOfSharing.name,
                                    label: Form_component_preferredWayOfSharing.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* Checkbox.Group */.X.Group, Form_component_objectSpread({
                                        style: {
                                            width: "100%"
                                        }
                                    }, Form_component_preferredWayOfSharing, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                            children: Form_component_preferredWayOfSharing.items.map(function(value) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                    span: 24,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* Checkbox */.X, {
                                                        value: value.value,
                                                        children: value.label
                                                    })
                                                }, value.value);
                                            })
                                        })
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: Form_component_rolesWantToPlay.name,
                                    label: Form_component_rolesWantToPlay.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* Checkbox.Group */.X.Group, Form_component_objectSpread({
                                        style: {
                                            width: "100%"
                                        }
                                    }, Form_component_rolesWantToPlay, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                            children: Form_component_rolesWantToPlay.items.map(function(value) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                    span: 24,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* Checkbox */.X, {
                                                        value: value.value,
                                                        children: value.label
                                                    })
                                                }, value.value);
                                            })
                                        })
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: wechatId.name,
                                    label: wechatId.placeholder,
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, Form_component_objectSpread({}, wechatId))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: bio.name,
                                    label: bio.placeholder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input.TextArea */.I.TextArea, Form_component_objectSpread({
                                        rows: 3
                                    }, bio))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: Form_component_channel.name,
                                    label: Form_component_channel.placeholder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auto_complete/* AutoComplete */.Q, Form_component_objectSpread({}, Form_component_channel))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: referrer.name,
                                    label: referrer.placeholder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, Form_component_objectSpread({}, referrer))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: "submit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubmitButton, {
                                        block: true,
                                        type: "primary",
                                        htmlType: "submit",
                                        loading: isSubmitting,
                                        disabled: !es/* isEmpty */.xbD(errors),
                                        children: submitBtnTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                    name: agreement.name,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* Checkbox */.X, Form_component_objectSpread({}, agreement, {
                                        children: agreement.content
                                    }))
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Form_component = (Form_component_Form);

;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/form/index.js


;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/ApplyEnd.component.js
function ApplyEnd_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ApplyEnd_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ApplyEnd_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var SuccessModal = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, ApplyEnd_component_objectSpread({
        title: "\u63D0\u4EA4\u6210\u529F\uFF01"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u6211\u4EEC\u5C06\u4E8E 3 \u4E2A\u5DE5\u4F5C\u65E5\u5185\u5BF9\u60A8\u63D0\u4EA4\u7684\u6750\u6599\u8FDB\u884C\u5BA1\u6838\uFF0C\u5E76\u4EE5\u3010AskTUG \u79C1\u4FE1\u3011\u5F62\u5F0F\u544A\u77E5\u60A8\u7ED3\u679C\u3002 \u82E5\u5BA1\u6838\u901A\u8FC7\uFF0C\u3010\u5FAE\u4FE1\u5C0F\u52A9\u624B\u3011\u5C06\u6DFB\u52A0\u60A8\u4E3A\u597D\u53CB\u5E76\u9080\u8BF7\u60A8\u8FDB\u5165 TUG \u4E13\u5C5E\u4EA4\u6D41\u7FA4\uFF0C\u656C\u8BF7\u7559\u610F\u3002"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u3010AskTUG \u79C1\u4FE1\u3011\u4F4D\u7F6E\uFF1A\u793E\u533A\u5BFC\u822A\u680F - \u95EE\u7B54\u8BBA\u575B - \u53F3\u4E0A\u89D2\u5934\u50CF\u4E0B\u62C9 - \u79C1\u4FE1"
            })
        ]
    }));
};
var ApplyEnd = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), successModal = ref[0], showSuccessModal = ref[1];
    var ref1 = (0,react.useState)(false), failModal = ref1[0], showFailModal = ref1[1];
    var ref2 = (0,react.useState)(""), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(), fieldMessage = ref3[0], setFieldMessage = ref3[1];
    var FailModal = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, ApplyEnd_component_objectSpread({
            title: "\u63D0\u4EA4\u5931\u8D25"
        }, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "System Error"
                }),
                !!fieldMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(fieldMessage).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                key,
                                ": ",
                                fieldMessage[key].join(", ")
                            ]
                        }, key);
                    })
                })
            ]
        }));
    }, [
        errorMessage,
        fieldMessage
    ]);
    var ref4 = (0,react.useState)(false), isSubmitting = ref4[0], setIsSubmitting = ref4[1];
    var handleSubmit = function(data) {
        setIsSubmitting(true);
        apply/* apply */.n(data).then(function() {
            showSuccessModal(true);
        }).catch(function(error) {
            setIsSubmitting(false);
            setErrorMessage(error.detail);
            setFieldMessage(error.errors);
            showFailModal(true);
        });
    };
    var handleSuccess = function() {
        router.push("/tug");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(applyEnd_styled_Wrapper, {
        id: "form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_component, {
                onSubmit: handleSubmit,
                isSubmitting: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal, {
                visible: successModal,
                onOk: function() {
                    return showSuccessModal(false);
                },
                afterClose: handleSuccess,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        type: "primary",
                        onClick: function() {
                            return showSuccessModal(false);
                        },
                        children: "\u786E\u8BA4"
                    }, "back")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FailModal, {
                visible: failModal,
                onOk: function() {
                    return showFailModal(false);
                },
                errorMessage: errorMessage,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        type: "primary",
                        onClick: function() {
                            return showFailModal(false);
                        },
                        children: "\u786E\u8BA4"
                    }, "back")
                })
            })
        ]
    });
};
/* harmony default export */ var ApplyEnd_component = (ApplyEnd);

;// CONCATENATED MODULE: ./src/pages/tug/apply/ApplyEnd/index.js


;// CONCATENATED MODULE: ./src/pages/tug/apply/Apply.component.js





var Apply = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyStart_component, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyEnd_component, {})
                })
            ]
        })
    });
};
/* harmony default export */ var Apply_component = (Apply);

;// CONCATENATED MODULE: ./src/pages/tug/apply/apply.data.js
var apply_data_title = "TiDB User Group \u4F1A\u5458\u7533\u8BF7";
var description = "\u52A0\u5165 TUG\uFF0C\u8BA9\u6570\u636E\u5E93\u3001\u5927\u6570\u636E\u4ECE\u4E1A\u8005\u627E\u5230\u81EA\u5DF1\u7684\u5708\u5B50\uFF1B" + "\u63A2\u7D22\u6280\u672F\u95EE\u9898\uFF0C\u968F\u65F6\u968F\u5730\u4EA4\u6D41\u6210\u957F\uFF0C\u89E3\u51B3\u95EE\u9898\uFF1B\u53D1\u8868\u6280\u672F\u89C1\u89E3\uFF0C\u6536\u83B7\u524D\u6CBF\u77E5\u8BC6\uFF0C\u63D0\u5347\u4E2A\u4EBA\u5F71\u54CD\u529B\u3002";

;// CONCATENATED MODULE: ./src/pages/tug/apply/index.page.js







var PageContent = function() {
    var ref = (0,react.useContext)(context/* AuthContext */.Vo), isAnonymous = ref.isAnonymous, login = ref.login;
    if (isAnonymous) {
        login();
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Apply_component, {});
};
var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: apply_data_title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {})
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,5127,9774,2888,179], function() { return __webpack_exec__(1157); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);